import styled from "@emotion/styled"

const PostWrapperItems = styled.div`
  margin-bottom: 30px;
`

export default PostWrapperItems
